import { render, staticRenderFns } from "./EmpresaBlocoInserirContratoManualmentePY.vue?vue&type=template&id=07552c9e&lang=pug"
import script from "./EmpresaBlocoInserirContratoManualmentePY.vue?vue&type=script&lang=js"
export * from "./EmpresaBlocoInserirContratoManualmentePY.vue?vue&type=script&lang=js"
import style0 from "./EmpresaBlocoInserirContratoManualmentePY.vue?vue&type=style&index=0&id=07552c9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports